import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React, { useContext } from 'react';
import { Button } from 'semantic-ui-react';
import _get from 'lodash/get';
import { Event } from '../../../../../analytics/components';
import { EVENT_CATEGORIES, EVENT_ACTIONS } from '../../../../../analytics/components/Event';
import { DynamicFormContext } from '../../context/DynamicFormContext';
function DynamicFormSubmitButton() {
  var _useContext = useContext(DynamicFormContext),
    event = _useContext.event,
    submitButtonProps = _useContext.submitButtonProps,
    isFormDisabled = _useContext.isFormDisabled,
    initializeFormData = _useContext.initializeFormData,
    displayErrors = _useContext.displayErrors,
    isFormValid = _useContext.isFormValid,
    loading = _useContext.loading;
  var label = submitButtonProps.label,
    fluid = submitButtonProps.fluid;
  var eventWithDefaultSubmitAction = _objectSpread({
    category: _get(event, 'category', EVENT_CATEGORIES.CONTACT_EVENT_CATEGORY),
    action: _get(event, 'action', EVENT_ACTIONS.CONTACT_SUBMIT_INQUIRY_EVENT_ACTION)
  }, event || {});
  return /*#__PURE__*/React.createElement(React.Fragment, null, !isFormDisabled && /*#__PURE__*/React.createElement(Event, {
    eventType: "click",
    event: eventWithDefaultSubmitAction
  }, /*#__PURE__*/React.createElement(Button, {
    primary: true,
    fluid: fluid,
    disabled: loading || displayErrors && !isFormValid
  }, label)), isFormDisabled && /*#__PURE__*/React.createElement(Button, {
    onClick: initializeFormData,
    primary: true,
    fluid: fluid
  }, "Send Another Message"));
}
export default DynamicFormSubmitButton;